export default "__VITE_ASSET__828ed95f__"